import { useMemo, useState } from 'react';

/**
 * Возвращает часть списка / весь список.
 * Используется для скрытия части элементов в интерфейсе (скрыть/показать)
 * @param items - переданный список
 * @param partialCount - размер урезанного списка
 * @param startState - начальное состояние true - урезать, false - возвращать весь список
 * @returns [   resultItems - итоговый список
                isPartial - метка, урезанный или нет
                setIsPartial - функция для управления   ]
 */
export function usePartialList<T>(items: T[], partialCount = 3, startState = true): [T[], boolean, (value: boolean) => void] {
    const [isPartial, setIsPartial] = useState(startState);

    const toggleState = (value: boolean) => {
        setIsPartial(value);
    };

    return useMemo(() => {
        const resultItems = isPartial ? items.slice(0, partialCount) : items;
        return ([
            resultItems,
            isPartial,
            toggleState,
        ]);
    }, [isPartial, items, partialCount]);
}
